import { useState, ReactElement } from "react";
import { Accordion, Card, useAccordionToggle } from "react-bootstrap";
import { BiCaretDown, BiCaretUp } from "react-icons/bi";
import { TranslationMessage } from "components";
import { NetworkStatus } from "components/NetworkStatus";
interface Props {
	faqList: [];
	questionKey?: string;
	answerKey?: string;
}

function CustomToggle({ children, eventKey }) {
	const [activeKey, setActiveKey] = useState(true);

	const decoratedOnClick = useAccordionToggle(eventKey, () => {
		setActiveKey((prevState) => !prevState);
	});

	return (
		<div onClick={decoratedOnClick}>
			<span style={activeKey ? { color: "#1A1E1E" } : { color: "#42056B" }}>
				{" "}
				{children}
			</span>
			{activeKey ? (
				<BiCaretDown className="accord-icon text-success" />
			) : (
				<BiCaretUp className="accord-icon text-purple" />
			)}
		</div>
	);
}

function FAQLayout({ faqList, questionKey, answerKey }: Props): ReactElement {
	return (
		<Accordion>
			{faqList?.length > 0 ? (
				faqList.map((item, index) => (
					<Card key={index}>
						<Card.Header>
							<CustomToggle eventKey={(index + 1).toString()}>
								<TranslationMessage
									data={item}
									value={questionKey ?? 'faq_question'}
									isHtmlParse
								/>
							</CustomToggle>
						</Card.Header>

						<Accordion.Collapse eventKey={(index + 1).toString()}>
							<Card.Body>
								<TranslationMessage
									data={item}
									value={answerKey ?? "faq_answer"}
									isHtmlParse
								/>
							</Card.Body>
						</Accordion.Collapse>
					</Card>
				))
			) : (
				<NetworkStatus loading={false} error={false} hasData={0} />
			)}
		</Accordion>
	);
}

export { FAQLayout };
